var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-felx justify-content-center align-items-center"},[_c('h4',[_vm._v("التحقق من البريد الإلكتروني")])])
}]

export { render, staticRenderFns }